import { Component, OnDestroy, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnDestroy {
  protected readonly title = signal('governx-ui');

  private readonly dismissTooltipEvents = [
    'scroll',
    'wheel',
    'touchmove',
    'pointerdown',
    'keydown',
  ] as const;

  private readonly boundDismissTooltips = this.dismissAllTooltips.bind(this);

  private static hasWindow(): boolean {
    return typeof window !== 'undefined';
  }

  private static hasDocument(): boolean {
    return typeof document !== 'undefined';
  }

  constructor() {
    if (!App.hasWindow()) return;
    // Globally closes floating tooltips during scroll/move interactions for consistent behavior.
    for (const eventName of this.dismissTooltipEvents) {
      window.addEventListener(eventName, this.boundDismissTooltips, {
        passive: true,
        capture: true,
      });
    }
  }

  ngOnDestroy(): void {
    if (!App.hasWindow()) return;
    for (const eventName of this.dismissTooltipEvents) {
      window.removeEventListener(eventName, this.boundDismissTooltips, true);
    }
  }

  // Removes all overlay tooltips instantly so none remain visible after navigation gestures.
  private dismissAllTooltips(): void {
    if (!App.hasDocument()) return;
    const openTooltips = document.querySelectorAll('.isg-tooltip');
    for (const tooltip of openTooltips) {
      tooltip.remove();
    }
  }
}
